import React from 'react';
import "../App.css"; // Ensure this includes your styles
import trek2 from '../images/mount_everest_banner.png'; // Import the Everest image

const PageInnerVideo = () => {
  return (
    <div className="position-relative" style={{ height: '140vh' }}>
      {/* Background Image Section */}
      <div
        className="bg-cover bg-image position-relative"
        style={{
          height: '100%',
          backgroundImage: `url(${trek2})`,
          backgroundSize: 'cover', // Ensure the image fits within the container
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat', // Prevent repeating if the image doesn't fully cover the container
        }}
      >
        {/* Overlay Content */}
        <div
          className="d-flex flex-column justify-content-center align-items-center"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            color: 'white',
            textAlign: 'center',
            zIndex: 2, // Ensures text is above the overlay
          }}
        >
          <h3 className="mt-3" style={{ fontSize: '2.5rem', fontWeight: 'bold' }}>
            Watch Our Video
          </h3>
          <p style={{ fontSize: '1.2rem', maxWidth: '600px' }}>
            Watch the full story of early Everest expeditions
          </p>
          {/* Play Button */}
          <a
            href="https://www.youtube.com/embed/Fp6Oqe0sO94?autoplay=1"
            target="_blank"
            rel="noopener noreferrer"
            className="btn mt-3"
            style={{
              borderRadius: '50%',
              width: '70px',
              height: '70px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: '1.5rem',
              boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
              backgroundColor: '#0077b6',
              border: '2px solid white',
              color: 'white',
            }}
          >
            <i className="fas fa-play"></i>
          </a>
        </div>
      </div>
    </div>
  );
};

export default PageInnerVideo;
